import {Component, Input} from '@angular/core';


@Component({
    selector: 'tfl-panel-details-group',
    template: `
        <div *ngIf="title" class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h4 class="panel-group-title">{{ title | translate }}</h4>
            </div>
        </div>
        <div class="row">
            <ng-content></ng-content>
        </div>
    `
})
export class PanelDetailsGroupComponent {
    @Input('title') title: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/panel-details/panel-details.group.component.ts